import { motion } from "framer-motion";
import CustomImage from "../CustomImage";
import { PhoneCall, X } from "lucide-react";

const IncomingCallPopupWrapper = ({ callMeta }: any) => {
  const handleRejectCall = () => {
    window.parent.postMessage(
      {
        ...callMeta,
        type: "MAXIMISE_CHAT_WIDGET_DISMISS_INCOMING_CALL",
      },
      "*"
    );
  };

  const handleAcceptCall = () => {
    window.parent.postMessage(
      {
        ...callMeta,
        type: "MAXIMISE_CHAT_WIDGET_ACCEPT_INCOMING_CALL",
      },
      "*"
    );
  };

  const closeMessages = () => {
    window.parent.postMessage(
      {
        type: "MAXIMISE_CHAT_WIDGET_DISMISS_INCOMING_CALL",
      },
      "*"
    );
  };

  // Animation variants for messages
  const messageVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: "easeOut",
      },
    },
  };

  return (
    <div className="flex h-full w-full items-end justify-end p-2">
      <div className="bg-transparent">
        <div className="flex justify-end px-3 pb-2">
          <div
            className="bg-gray-200 px-3 py-1 rounded-xl shadow-sm border cursor-pointer"
            onClick={() => closeMessages()}
          >
            <X className="size-3" />
          </div>
        </div>
        <div className="w-full flex justify-end items-end space-x-2 px-2">
          <div className="flex-shrink-0 mr-2"></div>
          <div className="flex flex-col h-full w-full items-end justify-end p-2">
            <motion.div
              className="bg-gray-50 border border-gray-200 rounded-xl text-sm shadow-sm w-full cursor-pointer max-w-60"
              initial="hidden"
              animate="visible"
              variants={messageVariants}
            >
              <div className="h-auto w-full flex flex-col rounded-xl p-4">
                <div className="flex-1 flex justify-start items-center gap-4">
                  <div className="relative h-16 w-16">
                    {/* First pulse layer */}
                    <div className="transition absolute inset-0 bg-secondary-500 rounded-full opacity-75 animate-ping"></div>

                    {/* Second pulse layer */}
                    <div className="transition absolute inset-0 bg-secondary-500 rounded-full opacity-50 animate-ping delay-100"></div>

                    {/* Third pulse layer */}
                    <div className="transition absolute inset-0 bg-secondary-500 rounded-full opacity-25 animate-ping delay-200"></div>

                    {/* Image container */}
                    <div className="relative h-full w-full flex items-center justify-center">
                      <CustomImage
                        src={callMeta?.metadata?.avatar_url}
                        alt={callMeta?.metadata?.first_name}
                        size={60}
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <div className="font-semibold text-sm">
                      {callMeta?.metadata?.first_name} is calling you
                    </div>
                    <div className="font-mediumopacity-75">
                      {callMeta?.metadata?.workspace_name} support
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
            <div className="flex justify-end pt-2">
              <div className="flex justify-around max-w-xs gap-6">
                <div>
                  <div
                    onClick={() => handleRejectCall()}
                    className="cursor-pointer h-10 w-10 bg-red-400 text-white rounded-lg flex justify-center items-center"
                  >
                    <X className="size-5" />
                  </div>
                </div>
                <div>
                  <div
                    onClick={() => handleAcceptCall()}
                    className="cursor-pointer h-10 w-10 bg-green-400 text-white rounded-lg flex justify-center items-center"
                  >
                    <PhoneCall className="size-5" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncomingCallPopupWrapper;
